// extracted by mini-css-extract-plugin
export default {"swish":"views-CheckoutPage-themes-BGH-payment-paymentIcons__swish--j1Lvb"};